
export type ProductName = 
    'spend'
  | 'monitor'
  | 'combined'
  | 'requests'
  | 'devtest'
  | 'insightsmetadata';

export class Product {
  constructor(
    public readonly name: Lowercase<string>,
    public readonly title: string,
    public readonly icon: ProductIcon,
    public readonly order: number,
    public readonly logoURL: string) { }

  nameMatches(str: string) {
    return str?.toLowerCase() === this.name;
  }
}

export interface ProductIcon {
  url: string;

  // ratio of this icon's width, relative to single icon
  widthRatio: number;
}

export const Products: Record<ProductName, Product> = {
  spend: new Product(
    'spend',
    'Optimize Spend',
    {
      url: 'assets/product-icons/SPEND_icon.svg',
      widthRatio: 1
    },
    0,
    'assets/img/SPEND_logo.png'
  ),
  monitor: new Product(
    'monitor',
    'Optimize Monitor',
    {
      url: 'assets/product-icons/MONITOR_icon.svg',
      widthRatio: 1
    },
    1,
    ''
  ),
  combined: new Product(
    'combined',
    'Spend & Usage',
    {
      url: 'assets/product-icons/COMBINED_icon.svg',
      widthRatio: 195.495 / 123
    },
    2,
    ''
  ),
  requests: new Product(
    'requests',
    'Optimize Requests',
    {
      url: 'assets/product-icons/REQUESTS_icon.svg',
      widthRatio: 1
    },
    3,
    ''
  ),
  devtest: new Product(
    'devtest',
    'DevTest',
    {
      url: 'assets/img/trg-icon.svg',
      widthRatio: 1
    },
    4,
    ''
  ),
  insightsmetadata: new Product(
    'insightsmetadata',
    'Insights Metadata',
    {
      url: 'assets/img/trg-icon.svg',
      widthRatio: 1
    },
    5,
    ''
  )
};

export const ProductList: Product[] = Object.keys(Products).map(k => Products[k]);

export function getProductDescriptor(productName: string): Product {
  productName = productName?.toLowerCase();

  let product = Products[productName];
  if (!product)
    throw new Error(`Unrecognized product '${productName}'`);

  return product;
}

export function getIconForKnownProduct(productName: string): ProductIcon {
  return getProductDescriptor(productName).icon;
}

export function getTitleForKnownProduct(productName: string): string {
  return getProductDescriptor(productName).title;
}

export function productOrderSort(a: string | Product, b: string | Product) {
  if (typeof a === 'string')
    a = getProductDescriptor(a);

  if (typeof b === 'string')
    b = getProductDescriptor(b);

  return a.order - b.order;
}
